module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/商业道德.8f8f05ec.png";